import PropTypes from 'prop-types';
import React from 'react';

export const OrbWrapper = ({ softOrder, Component, ...rest }) => {
  const details = {
    tacticName: 'ORB',
    category: 'Setup',
    type: 'ORB',
    domain: 'Underlying',
  };
  const priceToBreak = softOrder.priceToBreak;
  const priceToBreakLong = softOrder['priceToBreak (long)'];
  const priceToBreakShort = softOrder['priceToBreak (short)'];
  const breakBy = softOrder.breakBy;
  const candleDuration = softOrder.candleDuration;
  return (
    <Component
      details={details}
      priceToBreak={priceToBreak}
      priceToBreakLong={priceToBreakLong}
      priceToBreakShort={priceToBreakShort}
      candleDuration={candleDuration}
      breakBy={breakBy}
      {...rest}
    />
  );
};

OrbWrapper.propTypes = {
  Component: PropTypes.any,
  softOrder: PropTypes.shape({
    breakBy: PropTypes.any,
    candleDuration: PropTypes.any,
    priceToBreak: PropTypes.any
  })
};
